export const AGREEMENT_TYPE_IDS = {
  processingPersonalData: 'fe5d8b49-9886-48ff-aeb6-b2488e2691af',
  inclusionPersonnelReserve: '1578c8a5-5ebb-4e3d-9255-a5466ee3ad2c',
} as const;

/**
 * Соответствие чекбоксов согласий в форме соискателя и ID типов соглашений
 */
const CONSENT_TO_AGREEMENT_TYPE_ID: Record<string, string> = {
  consentProcessingPersonalData: AGREEMENT_TYPE_IDS.processingPersonalData,
  consentInclusionPersonnelReserve: AGREEMENT_TYPE_IDS.inclusionPersonnelReserve,
} as const;

export const getPreviewDocumentHref = (agreementTypeId: string, legalId: string | null): string =>
  `/preview-document?type_id=${agreementTypeId}&legal_id=${legalId}`;

export function getAgreementTypeIdsFromConsents(consents: {
  consentProcessingPersonalData?: boolean;
  consentInclusionPersonnelReserve?: boolean;
}): string[] {
  return (Object.entries(CONSENT_TO_AGREEMENT_TYPE_ID) as [keyof typeof consents, string][]).reduce<string[]>(
    (acc, [key, typeId]) => {
      if (consents[key]) acc.push(typeId);

      return acc;
    },
    [],
  );
}

export const digitsOnly = (value: string): string => {
  return value.replace(/\D/g, '');
};
